import { AutoFixHigh, Cancel } from "@mui/icons-material";
import { Box, Grid, Tab, Tabs } from "@mui/material";
import { observer } from "mobx-react";
import React, { useState } from "react";
import useStore from "../../helpers/useStore";
import { CalendarWithController } from "../../molecules/Calendar";
import CancellationDrawer from "../../molecules/Calendar/CancellationDrawer";
import EventShelf from "../../molecules/Calendar/EventShelf/EventShelf";
import CalendarDrawer from "../../molecules/Calendar/PatientDrawer/CalendarDrawer";
import RouteCalendar from "../../molecules/Calendar/RouteCalendar";
import TimeSheetCalendar from "../../molecules/Calendar/TimeSheetCalendar";
import HoverSidebar from "../../molecules/HoverSidebar";
import { CalendarContext } from "../../stores/Calendar/calendar.provider";
import { PatientsContext } from "../../stores/Patients/patients.provider";
import { UserContext } from "../../stores/User/User.provider";
import { AgentDrawerContent } from "./SchedulerAgent";
import SchedulerDialogs from "./SchedulerDialogs";
import SingleTherapistCalendarWithController from "../../molecules/Calendar/SingleTherapistCalendarWithController";

const Scheduler: React.FC = observer(() => {
  const patientDrawerWidth = 320;
  const rightSidebarWidth = 400;
  // Stornierungen is the working tab; the Agent (feature preview) is opt-in.
  const [rightTab, setRightTab] = useState<number>(0);

  // load calendar store and get the drawer open state
  const CalendarStore = useStore(CalendarContext);
  const { selectedPatientId: psPId } = useStore(PatientsContext);
  const UserStore = useStore(UserContext);
  const canSeeFeaturePreview = UserStore.hasPermission("featurePreview");
  const {
    patientDrawerOpen: pdOpenState,
    cancellationDrawerOpen,
    setCancellationDrawerOpen,
    selectedPatientId: csPId,
    routePlanningMode,
    timeSheetMode,
    singleTherapistView,
    continuousView,
  } = CalendarStore;
  if (!csPId && psPId) {
    // sync patient selection from patient store if needed
    CalendarStore.setSelectedPatientId(psPId);
  }
  const selectedPatientId = csPId || psPId;

  const patientDrawerOpen = (selectedPatientId && pdOpenState) || false;

  return (
    <Grid container height={"100%"}>
      <Grid item width={patientDrawerOpen ? patientDrawerWidth : 0}>
        <CalendarDrawer
          open={patientDrawerOpen}
          drawerWidth={patientDrawerWidth}
          showOpenButton={true}
        />
      </Grid>
      {/* Removed width={drawerOpen ? `calc(100% - ${patientDrawerWidth}px)` : "100%"} */}
      <Grid
        item
        width={`calc(${cancellationDrawerOpen ? "100%" : "98%"} - ${
          patientDrawerOpen ? patientDrawerWidth : 0
        }px - ${cancellationDrawerOpen ? rightSidebarWidth : 0}px)`}
        sx={{ transition: "width 0.3s ease" }}
      >
        <Grid
          container
          direction="column"
          sx={{
            border: "0px dotted blue",
            height: "100%",
            flexWrap: "nowrap",
            alignItems: "stretch",
          }}
        >
          <Grid item sx={{ border: "0px solid green", marginBottom: 1 }}>
            {/* unscheduled events */}
            <EventShelf
            // appointments={unscheduleds}
            // title={`Offene ${continuousView ? "Dauertermin" : "Termine"}`}
            // patient={patient}
            // onSelectEvent={handleSelectShelfAppointment}
            />
          </Grid>
          <Grid item sx={{ border: "0px solid red", flexGrow: 1, overflow: "hidden" }}>
            {
              <Box width="100%" sx={{ position: "absolute", zIndex: 1000 }}>
                {/* {pendingChanges.length > 0 && (
                  <LinearProgress
                    color="success"
                    variant="determinate"
                    value={queueProgress}
                    sx={{ width: "100%", marginBottom: 2 }}
                  />
                )} */}
              </Box>
            }
            {routePlanningMode ? (
              <RouteCalendar />
            ) : (
              <>
                <Box sx={{ display: timeSheetMode ? "block" : "none", height: "100%" }}>
                  <TimeSheetCalendar />
                </Box>
                <Box sx={{ display: singleTherapistView ? 'block' : 'none', height: '100%' }}>
                  <SingleTherapistCalendarWithController />
                </Box>
                <Box sx={{
                  ...(!timeSheetMode && !singleTherapistView
                    ? { display: 'block', height: '100%' }
                    : { visibility: 'hidden', position: 'absolute', width: '100%', height: '100%', pointerEvents: 'none' }
                  )
                }}>
                  <CalendarWithController />
                </Box>
              </>
            )}
            {/* {openWarningDialog && (
              <WarningDialog
                open={openWarningDialog} // Ensure the dialog is open
                onClose={() => setOpenWarningDialog(false)} // Close the dialog when user clicks close
                title="
Besuchen Sie Gap für einen Termin"
                content={warningMessage} // Set the warning message dynamically
                typeToProceed={["Ok"]} // Add your action buttons (e.g., OK)
              />
            )} */}
          </Grid>
        </Grid>
      </Grid>
      <Grid item sx={{ position: "relative" }}>
        <HoverSidebar
          onToggle={(open) => setCancellationDrawerOpen(open)}
          width={"" + rightSidebarWidth + "px"}
        >
          {/* <div>Hello world</div> */}
          <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
            {canSeeFeaturePreview && (
              <Tabs
                value={rightTab}
                onChange={(_, v) => setRightTab(v)}
                variant="fullWidth"
                sx={{
                  minHeight: 36,
                  borderBottom: "1px solid",
                  borderColor: "divider",
                  "& .MuiTab-root": { minHeight: 36, py: 0.5, fontSize: "0.75rem" },
                }}
              >
                <Tab icon={<Cancel sx={{ fontSize: 16 }} />} iconPosition="start" label="Stornierungen" />
                <Tab
                  icon={<AutoFixHigh sx={{ fontSize: 16 }} />}
                  iconPosition="start"
                  label="Agent"
                />
              </Tabs>
            )}
            <Box
              sx={{
                flex: 1,
                overflow: "auto",
                display: !canSeeFeaturePreview || rightTab === 0 ? "block" : "none",
              }}
            >
              <CancellationDrawer />
            </Box>
            {canSeeFeaturePreview && (
              <Box sx={{ flex: 1, overflow: "hidden", display: rightTab === 1 ? "block" : "none" }}>
                <AgentDrawerContent patientId={selectedPatientId} />
              </Box>
            )}
          </Box>
        </HoverSidebar>
      </Grid>

      {/* Centralized dialog management */}
      <SchedulerDialogs />
    </Grid>
  );
});
Scheduler.displayName = "Scheduler";

export default Scheduler;
